import React, { useState, useEffect } from 'react';
import { Alert, Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

const PaymentsBankCardChangesAlert = ({ theme }) => {
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const hideAlert = () => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    localStorage.setItem('bank_cards_alert_show_at', date.getTime());
    setIsAlertOpen(false);
  };

  useEffect(() => {
    const savedTime = localStorage.getItem('bank_cards_alert_show_at');
    const isTimeToShow = !savedTime || (savedTime && Date.now() > Number(savedTime));
    isTimeToShow && setIsAlertOpen(true);
  }, []);

  return (
    <Alert
      color="danger"
      className={theme ? `payment-conversion-alert-theme-${theme}` : ''}
      isOpen={isAlertOpen}
      toggle={hideAlert}
    >
      <Row>
        <Col xs="12" md="3" xl="3" className="bank-cards-alert-primary">
          <FormattedMessage
            id="paymants.cards-alert.primary"
            defaultMessage="Withdraw rubles and dollars on one single WMZ purse!"
          />
        </Col>
        <Col xs="12" md="9" xl="8" className="bank-cards-alert-secondary">
          <FormattedMessage
            id="paymants.cards-alert.secondary"
            defaultMessage="Starting from 27.08.19 it' s available to order payments in rubles on WebMoney's WMZ purse with the most profitable terms. Currency convertion uses Russian Federaion Central Bank order's date rate!"
          />
        </Col>
      </Row>
    </Alert>
  );
};

export default PaymentsBankCardChangesAlert;
